import { computed, inject, ref, type ComputedRef } from 'vue'
import type { MinibrowserContext } from './types'

export const useMinibrowser = (): {
  context: ComputedRef<ReturnType<MinibrowserContext>>
} => {
  const menuContext = inject<MinibrowserContext>('browserContext', () => {
    return {
      activatedMenuItemId: '',
      browserListId: '',
      isLoading: false,
      shouldFocusOnInput: ref(false),
      loadMore: {
        visible: false,
        current: 0,
        total: 0,
        loading: false,
      },
      clearNavigation: (): void => {},
      navigateTo: (): void => {},
      selectItem: (): void => {},
      focusOnFirstItem: (): void => {},
      focusOnLastItem: (): void => {},
      handleKeydownOnList: (): void => {},
      updateTabIndex: (): void => {},
      loadMoreItems: (): void => {},
    }
  })

  return {
    context: computed(() => menuContext()),
  }
}
